import { createFileRoute } from '@tanstack/react-router';

import { ProductMenu } from '../../components/ProductMenu/ProductMenu';

export const Route = createFileRoute('/_auth/product-menu')({
  component: ProductMenu,
});
